var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMaster(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 67,
    height: 44,
    viewBox: "0 0 67 44",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "payment logos/master"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.843713,
    y: 0.843713,
    width: 65.3279,
    height: 42.1974,
    rx: 7.65805,
    fill: "#020A23"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.843713,
    y: 0.843713,
    width: 65.3279,
    height: 42.1974,
    rx: 7.65805,
    stroke: "#A5B9D8",
    strokeWidth: 0.312574
  }), /*#__PURE__*/React.createElement("g", {
    id: "Element"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Element_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.3909 30.5447C35.9364 28.5416 37.5711 25.4329 37.5711 21.9424C37.5711 18.4519 35.9364 15.3432 33.3909 13.3401C35.2517 11.8758 37.5992 11.0023 40.1508 11.0023C46.1928 11.0023 51.0908 15.9004 51.0908 21.9424C51.0908 27.9844 46.1928 32.8825 40.1508 32.8825C37.5992 32.8825 35.2517 32.009 33.3909 30.5447ZM33.3909 30.5447C31.5301 32.009 29.1825 32.8825 26.631 32.8825C20.589 32.8825 15.6909 27.9844 15.6909 21.9424C15.6909 15.9004 20.589 11.0023 26.631 11.0023C29.1825 11.0023 31.5301 11.8758 33.3909 13.3401C30.8454 15.3432 29.2107 18.4519 29.2107 21.9424C29.2107 25.4329 30.8454 28.5416 33.3909 30.5447Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Element_3",
    d: "M33.3909 30.5447C35.9364 28.5416 37.5711 25.4329 37.5711 21.9424C37.5711 18.452 35.9364 15.3433 33.3909 13.3401C30.8453 15.3433 29.2107 18.452 29.2107 21.9424C29.2107 25.4329 30.8453 28.5416 33.3909 30.5447Z",
    fill: "#D8D8D8"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMaster);
export default __webpack_public_path__ + "static/media/master.7a4aa836d92f27ec7fc50e34c0d2b032.svg";
export { ForwardRef as ReactComponent };